module.exports = __webpack_public_path__ + "static/img/3.f59dcb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.png
// module id = 199
// module chunks = 1